var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"pa-0 pt-5 main-card",staticStyle:{"min-height":"100vh !important"},attrs:{"id":"mainMass"}},[_c('v-container',{staticClass:"mass-info pa-0"},[_c('v-skeleton-loader',{staticClass:"ms-skeleton",attrs:{"type":"article, button"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }